module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/pink_plus-7304a70f0664ca1de415c445559ed157.png";